import { useMemo } from 'react';
import MobileModal from '../../../../components/compositions/MobileModal/MobileModal';
import { CustomerPartnerTermsDto } from '../../../../apis/terms';

export interface TermsDetailModalProps {
  onCancel: () => void;
  visible?: boolean;
  terms?: CustomerPartnerTermsDto;
}

function TermsDetailModal(props: TermsDetailModalProps) {
  const { visible = false, onCancel, terms } = props;

  const srcDoc = useMemo(() => {
    const raw = terms?.currentTermsHistory.body || '';

    return `<!doctype html>
<html>
<head>
<meta name="viewport" content="width=device-width, initial-scale=1" />
<link
						rel="stylesheet"
						href="https://cdn.ckeditor.com/ckeditor5/45.2.1/ckeditor5.css"
					/>
<style>
  html, body { margin:0; padding:0; height:100%; }
  body {
    font-family: Pretendard, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Apple SD Gothic Neo", sans-serif;
    line-height:1.5; word-break:keep-all;
    -webkit-text-size-adjust:100%;
    padding: 20px;
    white-space: pre-wrap;
    word-wrap: break-word;
  }
</style>
</head>
<body class="ck ck-content">${raw}</body>
</html>`;
  }, [terms]);

  return (
    <MobileModal
      visible={visible}
      zIndex={100}
      onCancel={() => onCancel && onCancel()}
      title={terms?.title || ''}
    >
      {terms && (
        <div className="h-full">
          <iframe
            title="terms"
            sandbox=""
            srcDoc={srcDoc}
            style={{
              width: '100%',
              height: '100%',
              border: 'none',
              WebkitOverflowScrolling: 'touch',
            }}
          />
        </div>
      )}
    </MobileModal>
  );
}

export default TermsDetailModal;
